(function ($) {
  $.fn.filemanager = function (type, options) {
    type = type || 'file';
    this.on('click', function (e) {
      let route_prefix = (options && options.prefix) ? options.prefix : '/filemanager';
      let target_input = $('#' + $(this).data('input'));
      let target_preview = $('#' + $(this).data('preview'));
      window.open(route_prefix + '?type=' + type, 'FileManager', 'width=900,height=600');
      window.SetUrl = function (items) {
        console.log(items);
        let file_path = items.map(function (item) {
          if (item.url.indexOf(base_url) === 0) item.url = item.url.substring(base_url.length);
          if (item.thumb_url.indexOf(base_url) === 0) item.thumb_url = item.thumb_url.substring(base_url.length);
          return item.url;
        }).join(',');

        // set the value of the desired input to image url
        target_input.html('');

        // clear previous preview
        target_preview.html('');

        // set or change the preview image src
        items.forEach(function (item) {
          target_input.append(
            $('<input>').attr('type', 'hidden').attr('name', options.input_name).attr('value', item.url)
          );
          target_preview.append(
            $('<img>').css('height', '5rem').attr('src', base_url + item.thumb_url)
          );
        });

        // trigger change event
        target_preview.trigger('change');
      };
      return false;
    });
  };

  $.fn.fileResetor = function () {
    this.on('click', function (e) {
      let target_input = $('#' + $(this).data('input'));
      let target_preview = $('#' + $(this).data('preview'));
      target_input.html('');
      target_preview.html('');
    });
  };
})(jQuery);
